import { select, takeLeading, put } from 'redux-saga/effects';
import { callApi, handleError } from 'helpers/saga-helpers';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { get } from 'lodash';
import accessTokenStorage from 'containers/services/security/access-token-storage';

import {
  startLoading,
  stopLoading,
} from 'containers/AppContainer/Loader/action';
import {
  resetExpertReport,
  resetJudgementAdd,
  resetJudgementOnMerits,
  resetMultipleJudgementOnMerits,
  setJudgementAddAppeal,
  setExpertiseRaport,
  setExpertiseRaportAppeal,
  setJudgementAdd,
  setJudgementOnMerits,
  setJudgementOnMeritsAppeal,
  setJudgementOnMeritsMultiple,
  setAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { REQUEST_GET_JUDGEMENTS } from 'containers/common/LegalProceedings/constants';

const resetActions = [
  resetJudgementAdd,
  resetExpertReport,
  resetJudgementOnMerits,
  resetMultipleJudgementOnMerits,
];

export function* resetSetJudgements() {
  for (const action of resetActions) {
    yield put(action());
  }
}
export function* setJudgements(judgements: any, isAppeal: boolean) {
  if (isAppeal) {
    yield put(setJudgementAdd(get(judgements, 'judgementAdd', {})));
    yield put(
      setJudgementOnMeritsMultiple(
        get(judgements, 'judgementOnMeritsMutiple', {}),
      ),
    );
    yield put(setJudgementOnMerits(get(judgements, 'judgementOnMerits', {})));
    yield put(setExpertiseRaport(get(judgements, 'expertiseRapport', {})));
    yield put(
      setJudgementAddAppeal(get(judgements, 'judgementAddFirstInstance', {})),
    );

    yield put(
      setAppealOnMeritsMultiple(
        get(judgements, 'judgementOnMeritsMutipleFirstInstance', {}),
      ),
    );
    yield put(
      setExpertiseRaportAppeal(
        get(judgements, 'expertiseRapportFirstInstance', {}),
      ),
    );
    yield put(
      setJudgementOnMeritsAppeal(
        get(judgements, 'judgementOnMeritsFirstInstance', {}),
      ),
    );
  } else {
    yield put(setJudgementAdd(get(judgements, 'judgementAdd', {})));
    yield put(
      setJudgementOnMeritsMultiple(
        get(judgements, 'judgementOnMeritsMutiple', {}),
      ),
    );
    yield put(setJudgementOnMerits(get(judgements, 'judgementOnMerits', {})));
    yield put(setExpertiseRaport(get(judgements, 'expertiseRapport', {})));
  }
}

export function* getJudgements(action: {
  type: string;
  claimId: number;
  procedureType: string;
  judiciaryProcessId: number;
}): Generator<unknown> {
  const { claimId, procedureType, judiciaryProcessId } = action;
  const isFirstInstance = procedureType === PROCEDURE_TYPES.FIRST_INSTANCE;

  const firstInstanceLoaders = [
    LOADERS.JUDGEMENT_ADD,
    LOADERS.EXPERT_REPORT,
    LOADERS.JUDGEMENT_ON_MERITS,
    LOADERS.MULTIPLE_JUDGEMENT_ON_MERITS,
  ];

  const appealLoaders = [
    LOADERS.JUDGEMENT_ADD_APPEAL,
    LOADERS.EXPERT_REPORT_APPEAL,
    LOADERS.JUDGEMENT_ON_MERITS,
    LOADERS.MULTIPLE_JUDGEMENT_ON_MERITS,
  ];
  const loaders = isFirstInstance ? firstInstanceLoaders : appealLoaders;

  try {
    const token = get(accessTokenStorage.get(), 'token')
      ? get(accessTokenStorage.get(), 'token')
      : yield select(makeSelectKeycloakToken());
    const path = `/corporeal/judgement/${claimId}/${judiciaryProcessId}/${procedureType}`;
    const formattedPath = get(accessTokenStorage.get(), 'token')
      ? path
      : path + '?isIntervenant=true';
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    yield resetSetJudgements();
    for (const loader of loaders) {
      yield put(startLoading(loader));
    }

    yield callApi(
      formattedPath,
      {},
      options,
      [],
      undefined,
      undefined,
      false,
      undefined,
      e => {
        return setJudgements(e, !isFirstInstance);
      },
    );
  } catch (err) {
    yield* handleError(err);
  } finally {
    for (const loader of loaders) {
      yield put(stopLoading(loader));
    }
  }
}

export function* requestGetJudgementsSaga() {
  yield takeLeading(REQUEST_GET_JUDGEMENTS, getJudgements);
}

export default [requestGetJudgementsSaga];
